import axios from "../utils/axios";

export const getAbout = async () => {
    const response = await axios.get('/about-us');
    return response.data;
};

export const updateAbout = async (data) => {
    const response = await axios.put('/about-us', data, {
        headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
};
